import { createSlice } from "@reduxjs/toolkit";
import { InitialStateSlice } from "./create-dispatch-step";

const initialState: InitialStateSlice = {
  value: 0,
};

const AddCreditCardStepSlice = createSlice({
  name: "addCreditCardStep",
  initialState,
  reducers: {
    nextCreditCardPage: (state) => {
      state.value += 1;
    },
    prevCreditCardPage: (state) => {
      state.value -= 1;
    },
    resetCreditCardStep: (state) => {
      state.value = 0;
    },
  },
});

export const { nextCreditCardPage, prevCreditCardPage, resetCreditCardStep } =
  AddCreditCardStepSlice.actions;
export default AddCreditCardStepSlice.reducer;
